
Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  objectEnumValues,
  makeStrictEnum,
  Public,
  getRuntime,
  skip
} = require('@prisma/client/runtime/index-browser.js')


const Prisma = {}

exports.Prisma = Prisma
exports.$Enums = {}

/**
 * Prisma Client JS version: 5.22.0
 * Query Engine version: 605197351a3c8bdd595af2d2a9bc3025bca48ea2
 */
Prisma.prismaVersion = {
  client: "5.22.0",
  engine: "605197351a3c8bdd595af2d2a9bc3025bca48ea2"
}

Prisma.PrismaClientKnownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientKnownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientUnknownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientRustPanicError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientRustPanicError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientInitializationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientInitializationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientValidationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientValidationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.NotFoundError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`NotFoundError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`sqltag is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.empty = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`empty is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.join = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`join is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.raw = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`raw is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.validator = Public.validator

/**
* Extensions
*/
Prisma.getExtensionContext = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.getExtensionContext is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.defineExtension = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.defineExtension is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = objectEnumValues.instances.DbNull
Prisma.JsonNull = objectEnumValues.instances.JsonNull
Prisma.AnyNull = objectEnumValues.instances.AnyNull

Prisma.NullTypes = {
  DbNull: objectEnumValues.classes.DbNull,
  JsonNull: objectEnumValues.classes.JsonNull,
  AnyNull: objectEnumValues.classes.AnyNull
}



/**
 * Enums
 */

exports.Prisma.TransactionIsolationLevel = makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
});

exports.Prisma.UsersScalarFieldEnum = {
  id: 'id',
  parent: 'parent',
  name: 'name',
  last_name: 'last_name',
  email: 'email',
  email_verified: 'email_verified',
  uid: 'uid',
  phone: 'phone',
  nick: 'nick',
  status: 'status',
  altenar: 'altenar',
  provider: 'provider',
  kyc_status: 'kyc_status',
  kyc_level: 'kyc_level',
  available_balance: 'available_balance',
  betting_bonus_balance: 'betting_bonus_balance',
  casino_bonus_balance: 'casino_bonus_balance',
  deposit_balance: 'deposit_balance',
  last_session: 'last_session',
  created_at: 'created_at',
  updated_at: 'updated_at',
  is_test: 'is_test',
  notes: 'notes',
  last_bet_date: 'last_bet_date',
  last_deposit_date: 'last_deposit_date',
  last_game_date: 'last_game_date',
  last_withdrawal_date: 'last_withdrawal_date',
  topup_id: 'topup_id',
  btag: 'btag',
  click_id: 'click_id',
  affiliate_id: 'affiliate_id',
  monthly_wager: 'monthly_wager',
  vip_level: 'vip_level',
  vip_level_expiry_date: 'vip_level_expiry_date',
  vip_updated_at: 'vip_updated_at',
  landing_id: 'landing_id',
  partner_id: 'partner_id'
};

exports.Prisma.DocumentsScalarFieldEnum = {
  id: 'id',
  user_id: 'user_id',
  type: 'type',
  number: 'number',
  notes: 'notes',
  status: 'status',
  created_at: 'created_at',
  updated_at: 'updated_at',
  updated_by: 'updated_by',
  document_back_url: 'document_back_url',
  document_front_url: 'document_front_url',
  external_id: 'external_id',
  selfie_url: 'selfie_url'
};

exports.Prisma.ProfilesScalarFieldEnum = {
  id: 'id',
  user_id: 'user_id',
  born_day: 'born_day',
  gender: 'gender',
  country: 'country',
  city: 'city',
  address: 'address',
  full_profile: 'full_profile',
  contact_preferences: 'contact_preferences',
  document_type: 'document_type',
  document_id: 'document_id',
  casino: 'casino',
  bets: 'bets',
  deposits_limit: 'deposits_limit',
  withdrawals_limit: 'withdrawals_limit',
  created_at: 'created_at',
  updated_at: 'updated_at',
  first_deposit: 'first_deposit',
  first_deposit_date: 'first_deposit_date',
  favorite_club: 'favorite_club',
  favorite_games: 'favorite_games',
  gateways: 'gateways',
  wager_month: 'wager_month'
};

exports.Prisma.BetsScalarFieldEnum = {
  id: 'id',
  user_id: 'user_id',
  event_id: 'event_id',
  amount: 'amount',
  reference: 'reference',
  mode: 'mode',
  description: 'description',
  status: 'status',
  ip: 'ip',
  event: 'event',
  winnings: 'winnings',
  bet_stake: 'bet_stake',
  frontend_type: 'frontend_type',
  sport_ids: 'sport_ids',
  event_count: 'event_count',
  win_amount: 'win_amount',
  refund_amount: 'refund_amount',
  debit_amount: 'debit_amount',
  stake_decrease_amount: 'stake_decrease_amount',
  last_event: 'last_event',
  last_event_date: 'last_event_date',
  system_bet: 'system_bet',
  odds: 'odds',
  total_cashout: 'total_cashout',
  bonus_amount: 'bonus_amount',
  bonus_balance: 'bonus_balance',
  bonus_account_id: 'bonus_account_id',
  bonus_update_amount: 'bonus_update_amount',
  bonus_update_balance: 'bonus_update_balance',
  created_at: 'created_at',
  updated_at: 'updated_at',
  championship_ids: 'championship_ids',
  event_ids: 'event_ids'
};

exports.Prisma.BetsEventsScalarFieldEnum = {
  id: 'id',
  bet_id: 'bet_id',
  event_type: 'event_type',
  transaction_id: 'transaction_id',
  amount: 'amount',
  event_date: 'event_date',
  description: 'description',
  bonus_account_id: 'bonus_account_id',
  bonus_user_id: 'bonus_user_id',
  created_at: 'created_at',
  updated_at: 'updated_at',
  bet_event_id: 'bet_event_id'
};

exports.Prisma.BetBonusesScalarFieldEnum = {
  id: 'id',
  user_id: 'user_id',
  bonus_plan_id: 'bonus_plan_id',
  bonus_account_id: 'bonus_account_id',
  bonus_balance: 'bonus_balance',
  bonus_status: 'bonus_status',
  transaction_id: 'transaction_id',
  bonus_type: 'bonus_type',
  awarded_bonus: 'awarded_bonus',
  created_at: 'created_at',
  updated_at: 'updated_at',
  bonus_amount: 'bonus_amount',
  bonus_id: 'bonus_id',
  expiration_date: 'expiration_date'
};

exports.Prisma.FreeSpinsScalarFieldEnum = {
  id: 'id',
  user_id: 'user_id',
  provider: 'provider',
  games: 'games',
  spins_number: 'spins_number',
  activation_date: 'activation_date',
  expiration_date: 'expiration_date',
  status: 'status',
  amount_won: 'amount_won',
  created_at: 'created_at',
  updated_at: 'updated_at',
  bonus_id: 'bonus_id',
  description: 'description'
};

exports.Prisma.GamesScalarFieldEnum = {
  id: 'id',
  user_id: 'user_id',
  provider: 'provider',
  result: 'result',
  amount: 'amount',
  currency: 'currency',
  i_gameid: 'i_gameid',
  i_gamedesc: 'i_gamedesc',
  i_actionid: 'i_actionid',
  jackpot_win: 'jackpot_win',
  rolled_back: 'rolled_back',
  i_rollback: 'i_rollback',
  created_at: 'created_at',
  updated_at: 'updated_at'
};

exports.Prisma.TransactionsScalarFieldEnum = {
  id: 'id',
  user_id: 'user_id',
  type: 'type',
  amount: 'amount',
  currency: 'currency',
  gateway: 'gateway',
  id_txn: 'id_txn',
  deposit_id: 'deposit_id',
  status: 'status',
  withdrawal_id: 'withdrawal_id',
  description: 'description',
  approval_date: 'approval_date',
  expiration_date: 'expiration_date',
  ext_transaction_id: 'ext_transaction_id',
  created_at: 'created_at',
  updated_at: 'updated_at',
  updated_by: 'updated_by',
  bonus_percentage: 'bonus_percentage'
};

exports.Prisma.WalletsScalarFieldEnum = {
  id: 'id',
  user_id: 'user_id',
  wallet_id: 'wallet_id',
  address: 'address',
  currency: 'currency',
  status: 'status',
  type: 'type',
  network: 'network',
  bank: 'bank',
  method: 'method',
  created_at: 'created_at',
  updated_at: 'updated_at'
};

exports.Prisma.CasinoGamesScalarFieldEnum = {
  id_juego: 'id_juego',
  title: 'title',
  identifier: 'identifier',
  identifier2: 'identifier2',
  provider: 'provider',
  producer: 'producer',
  category: 'category',
  theme: 'theme',
  has_freespins: 'has_freespins',
  feature_group: 'feature_group',
  jackpot_type: 'jackpot_type',
  forbid_bonus_play: 'forbid_bonus_play',
  payout: 'payout',
  volatility_rating: 'volatility_rating',
  released_at: 'released_at',
  hit_rate: 'hit_rate',
  bonus_buy: 'bonus_buy',
  has_jackpot: 'has_jackpot',
  ways: 'ways',
  has_live: 'has_live',
  sections: 'sections',
  active: 'active',
  usd_only: 'usd_only'
};

exports.Prisma.AdminsScalarFieldEnum = {
  id: 'id',
  name: 'name',
  last_name: 'last_name',
  email: 'email',
  role: 'role',
  permissions: 'permissions',
  balance: 'balance',
  status: 'status',
  created_at: 'created_at',
  updated_at: 'updated_at'
};

exports.Prisma.AgenteScalarFieldEnum = {
  id_agente: 'id_agente',
  id_subconcesionario: 'id_subconcesionario',
  numero_identidad: 'numero_identidad',
  nombres: 'nombres',
  apellidos: 'apellidos',
  fecha_nacimiento: 'fecha_nacimiento',
  pais: 'pais',
  direccion: 'direccion',
  telefono: 'telefono',
  ggr: 'ggr',
  recargas: 'recargas',
  premios: 'premios',
  saldo: 'saldo',
  ciudad: 'ciudad',
  email: 'email',
  fecha_creacion: 'fecha_creacion',
  nombre_banco: 'nombre_banco',
  nombre_titular: 'nombre_titular',
  numero_cuenta: 'numero_cuenta',
  sexo: 'sexo',
  telefono_fijo: 'telefono_fijo',
  tipo_cuenta: 'tipo_cuenta',
  tipo_documento: 'tipo_documento',
  nombre_usuario: 'nombre_usuario',
  comision: 'comision',
  firebase_id: 'firebase_id',
  altenar: 'altenar',
  tipo_comercio: 'tipo_comercio',
  comision_afiliados: 'comision_afiliados',
  comision_apuestas: 'comision_apuestas',
  comision_premios: 'comision_premios',
  comision_recargas: 'comision_recargas',
  configuration: 'configuration',
  tipo_agente: 'tipo_agente',
  departamento: 'departamento',
  saldo_disponible: 'saldo_disponible',
  saldo_premios: 'saldo_premios',
  saldo_comision: 'saldo_comision'
};

exports.Prisma.ComisionScalarFieldEnum = {
  id_comision: 'id_comision',
  id_autor: 'id_autor',
  fecha: 'fecha',
  valor_transaccion: 'valor_transaccion',
  valor_comision: 'valor_comision',
  id_transaccion: 'id_transaccion',
  tipo_comision: 'tipo_comision'
};

exports.Prisma.ConcesionarioScalarFieldEnum = {
  id_concesionario: 'id_concesionario',
  numero_identidad: 'numero_identidad',
  nombres: 'nombres',
  apellidos: 'apellidos',
  fecha_nacimiento: 'fecha_nacimiento',
  pais: 'pais',
  direccion: 'direccion',
  telefono: 'telefono',
  ggr: 'ggr',
  recargas: 'recargas',
  premios: 'premios',
  saldo: 'saldo',
  ciudad: 'ciudad',
  email: 'email',
  fecha_creacion: 'fecha_creacion',
  nombre_banco: 'nombre_banco',
  nombre_titular: 'nombre_titular',
  numero_cuenta: 'numero_cuenta',
  sexo: 'sexo',
  telefono_fijo: 'telefono_fijo',
  tipo_cuenta: 'tipo_cuenta',
  tipo_documento: 'tipo_documento',
  nombre_usuario: 'nombre_usuario',
  comision: 'comision',
  premios_sub: 'premios_sub',
  recargas_sub: 'recargas_sub',
  premios_agente: 'premios_agente',
  recargas_agente: 'recargas_agente',
  firebase_id: 'firebase_id',
  tipo_comercio: 'tipo_comercio',
  comision_afiliados: 'comision_afiliados',
  comision_apuestas: 'comision_apuestas',
  comision_premios: 'comision_premios',
  comision_recargas: 'comision_recargas',
  tipo_agente: 'tipo_agente',
  departamento: 'departamento',
  configuration: 'configuration',
  saldo_disponible: 'saldo_disponible',
  saldo_premios: 'saldo_premios',
  saldo_comision: 'saldo_comision'
};

exports.Prisma.SubconcesionarioScalarFieldEnum = {
  id_subconcesionario: 'id_subconcesionario',
  id_concesionario: 'id_concesionario',
  numero_identidad: 'numero_identidad',
  nombres: 'nombres',
  apellidos: 'apellidos',
  fecha_nacimiento: 'fecha_nacimiento',
  pais: 'pais',
  direccion: 'direccion',
  telefono: 'telefono',
  ggr: 'ggr',
  recargas: 'recargas',
  premios: 'premios',
  saldo: 'saldo',
  ciudad: 'ciudad',
  email: 'email',
  fecha_creacion: 'fecha_creacion',
  nombre_banco: 'nombre_banco',
  nombre_titular: 'nombre_titular',
  numero_cuenta: 'numero_cuenta',
  sexo: 'sexo',
  telefono_fijo: 'telefono_fijo',
  tipo_cuenta: 'tipo_cuenta',
  tipo_documento: 'tipo_documento',
  nombre_usuario: 'nombre_usuario',
  comision: 'comision',
  firebase_id: 'firebase_id',
  tipo_comercio: 'tipo_comercio',
  comision_afiliados: 'comision_afiliados',
  comision_apuestas: 'comision_apuestas',
  comision_premios: 'comision_premios',
  comision_recargas: 'comision_recargas',
  tipo_agente: 'tipo_agente',
  departamento: 'departamento',
  configuration: 'configuration',
  saldo_disponible: 'saldo_disponible',
  saldo_premios: 'saldo_premios',
  saldo_comision: 'saldo_comision'
};

exports.Prisma.TransaccionScalarFieldEnum = {
  id_transaccion: 'id_transaccion',
  tipo: 'tipo',
  monto: 'monto',
  fecha: 'fecha',
  modo: 'modo',
  estado: 'estado',
  tipo_usuario: 'tipo_usuario',
  id_agente: 'id_agente',
  id_concesionario: 'id_concesionario',
  id_subconcesionario: 'id_subconcesionario',
  cliente_correo: 'cliente_correo',
  cliente_nombre: 'cliente_nombre',
  id_autor: 'id_autor',
  id_usuario: 'id_usuario',
  id_admin: 'id_admin',
  id_referencia: 'id_referencia',
  id_voucher: 'id_voucher'
};

exports.Prisma.ActivityScalarFieldEnum = {
  id: 'id',
  user_id: 'user_id',
  table_id: 'table_id',
  source: 'source',
  type: 'type',
  amount: 'amount',
  end_balance: 'end_balance',
  created_at: 'created_at',
  end_available_balance: 'end_available_balance',
  end_deposit_balance: 'end_deposit_balance',
  notes: 'notes',
  end_betting_bonus_balance: 'end_betting_bonus_balance'
};

exports.Prisma.RetriesScalarFieldEnum = {
  id: 'id',
  user_id: 'user_id',
  password_counter: 'password_counter',
  password_date: 'password_date',
  email_counter: 'email_counter',
  email_date: 'email_date',
  created_at: 'created_at',
  updated_at: 'updated_at',
  email_change_counter: 'email_change_counter',
  email_change_date: 'email_change_date'
};

exports.Prisma.MovimientosScalarFieldEnum = {
  id: 'id',
  transaction_id: 'transaction_id',
  type: 'type',
  amount: 'amount',
  creator_id: 'creator_id',
  creator_end_balance: 'creator_end_balance',
  receiver_id: 'receiver_id',
  receiver_end_balance: 'receiver_end_balance',
  receiver_type: 'receiver_type',
  created_at: 'created_at',
  notes: 'notes',
  creator_end_commissions_balance: 'creator_end_commissions_balance',
  creator_end_deposit_balance: 'creator_end_deposit_balance',
  creator_end_prizes_balance: 'creator_end_prizes_balance',
  receiver_end_commissions_balance: 'receiver_end_commissions_balance',
  receiver_end_deposit_balance: 'receiver_end_deposit_balance',
  receiver_end_prizes_balance: 'receiver_end_prizes_balance',
  creator_end_balances: 'creator_end_balances',
  receiver_end_balances: 'receiver_end_balances'
};

exports.Prisma.Agents_betsScalarFieldEnum = {
  id: 'id',
  agent_id: 'agent_id',
  event_id: 'event_id',
  amount: 'amount',
  reference: 'reference',
  mode: 'mode',
  description: 'description',
  status: 'status',
  ip: 'ip',
  event: 'event',
  winnings: 'winnings',
  bet_stake: 'bet_stake',
  frontend_type: 'frontend_type',
  sport_ids: 'sport_ids',
  event_count: 'event_count',
  refund_amount: 'refund_amount',
  debit_amount: 'debit_amount',
  stake_decrease_amount: 'stake_decrease_amount',
  last_event: 'last_event',
  last_event_date: 'last_event_date',
  system_bet: 'system_bet',
  odds: 'odds',
  total_cashout: 'total_cashout',
  win_amount: 'win_amount',
  bonus_amount: 'bonus_amount',
  bonus_balance: 'bonus_balance',
  bonus_account_id: 'bonus_account_id',
  bonus_update_amount: 'bonus_update_amount',
  bonus_update_balance: 'bonus_update_balance',
  created_at: 'created_at',
  updated_at: 'updated_at',
  is_paid: 'is_paid',
  paid_at: 'paid_at',
  regulator_id: 'regulator_id'
};

exports.Prisma.Bets_eventsScalarFieldEnum = {
  id: 'id',
  bet_id: 'bet_id',
  event_type: 'event_type',
  transaction_id: 'transaction_id',
  amount: 'amount',
  event_date: 'event_date',
  description: 'description',
  bonus_account_id: 'bonus_account_id',
  bonus_user_id: 'bonus_user_id',
  created_at: 'created_at',
  updated_at: 'updated_at',
  bet_event_id: 'bet_event_id'
};

exports.Prisma.BonusesScalarFieldEnum = {
  id: 'id',
  type: 'type',
  code: 'code',
  campaign_id: 'campaign_id',
  active: 'active',
  start_date: 'start_date',
  end_date: 'end_date',
  priority: 'priority',
  created_at: 'created_at',
  first_deposit: 'first_deposit',
  amount: 'amount',
  bet_level: 'bet_level',
  bonus_expiration: 'bonus_expiration',
  game: 'game',
  name: 'name',
  provider: 'provider',
  rules: 'rules',
  spins_number: 'spins_number',
  type_bonus: 'type_bonus',
  dispatcher: 'dispatcher',
  rollover: 'rollover',
  descriptions: 'descriptions',
  days: 'days',
  updated_at: 'updated_at'
};

exports.Prisma.SesionesScalarFieldEnum = {
  id: 'id',
  id_agente: 'id_agente',
  ip: 'ip',
  browser: 'browser',
  os: 'os',
  dispositivo: 'dispositivo',
  modelo: 'modelo',
  proveedor: 'proveedor',
  ciudad: 'ciudad',
  pais: 'pais',
  fecha_creacion: 'fecha_creacion',
  fecha_actualizacion: 'fecha_actualizacion'
};

exports.Prisma.VouchersScalarFieldEnum = {
  id: 'id',
  user_id: 'user_id',
  status: 'status',
  bank: 'bank',
  deposit_date: 'deposit_date',
  number: 'number',
  value: 'value',
  description: 'description',
  feedback: 'feedback',
  document_url: 'document_url',
  created_at: 'created_at',
  updated_at: 'updated_at',
  updated_by: 'updated_by',
  transaction_id: 'transaction_id',
  is_duplicated: 'is_duplicated'
};

exports.Prisma.Pagos_comisionesScalarFieldEnum = {
  id: 'id',
  id_autor: 'id_autor',
  fecha: 'fecha',
  comision_recargas: 'comision_recargas',
  comision_premios: 'comision_premios',
  comision_afiliados: 'comision_afiliados',
  comision_apuestas: 'comision_apuestas',
  tipo: 'tipo',
  created_at: 'created_at'
};

exports.Prisma.Agents_vouchersScalarFieldEnum = {
  id: 'id',
  user_id: 'user_id',
  status: 'status',
  bank: 'bank',
  deposit_date: 'deposit_date',
  number: 'number',
  value: 'value',
  description: 'description',
  feedback: 'feedback',
  document_url: 'document_url',
  created_at: 'created_at',
  updated_at: 'updated_at',
  updated_by: 'updated_by'
};

exports.Prisma.ReferralsScalarFieldEnum = {
  id: 'id',
  user_id: 'user_id',
  created_at: 'created_at',
  updated_at: 'updated_at',
  amount: 'amount',
  referred_id: 'referred_id',
  status: 'status'
};

exports.Prisma.RaffleScalarFieldEnum = {
  id: 'id',
  name: 'name',
  start_date: 'start_date',
  end_date: 'end_date',
  status: 'status',
  prize_description: 'prize_description',
  amount_tickets: 'amount_tickets',
  type: 'type',
  created_at: 'created_at',
  updated_at: 'updated_at',
  event: 'event'
};

exports.Prisma.Raffle_ticketsScalarFieldEnum = {
  id: 'id',
  user_id: 'user_id',
  ticket_number: 'ticket_number',
  created_at: 'created_at',
  updated_at: 'updated_at',
  raffle_id: 'raffle_id',
  winner: 'winner'
};

exports.Prisma.Users_raffleScalarFieldEnum = {
  id: 'id',
  user_id: 'user_id',
  raffle_id: 'raffle_id',
  created_at: 'created_at',
  updated_at: 'updated_at'
};

exports.Prisma.SessionsScalarFieldEnum = {
  id: 'id',
  user_id: 'user_id',
  ip: 'ip',
  browser: 'browser',
  os: 'os',
  device: 'device',
  model: 'model',
  vendor: 'vendor',
  city: 'city',
  country: 'country',
  created_at: 'created_at',
  updated_at: 'updated_at',
  latitude: 'latitude',
  longitude: 'longitude'
};

exports.Prisma.CommissionsScalarFieldEnum = {
  id: 'id',
  partner_id: 'partner_id',
  type: 'type',
  value: 'value',
  transaction_id: 'transaction_id',
  created_at: 'created_at',
  updated_at: 'updated_at'
};

exports.Prisma.PartnersScalarFieldEnum = {
  id: 'id',
  name: 'name',
  last_name: 'last_name',
  email: 'email',
  birth_date: 'birth_date',
  document_id: 'document_id',
  city: 'city',
  department: 'department',
  balance: 'balance',
  uid: 'uid',
  created_at: 'created_at',
  updated_at: 'updated_at',
  status: 'status',
  traffic_sources: 'traffic_sources',
  type: 'type',
  business_name: 'business_name',
  business_document_id: 'business_document_id',
  email_verified: 'email_verified',
  phone: 'phone',
  last_session: 'last_session',
  notes: 'notes',
  ref: 'ref',
  kyc_level: 'kyc_level',
  kyc_status: 'kyc_status',
  onboarding: 'onboarding'
};

exports.Prisma.Affiliates_sessionsScalarFieldEnum = {
  id: 'id',
  ip: 'ip',
  device_info: 'device_info',
  geo_info: 'geo_info',
  created_at: 'created_at',
  updated_at: 'updated_at',
  partner_id: 'partner_id'
};

exports.Prisma.SortOrder = {
  asc: 'asc',
  desc: 'desc'
};

exports.Prisma.NullableJsonNullValueInput = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull
};

exports.Prisma.QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
};

exports.Prisma.NullsOrder = {
  first: 'first',
  last: 'last'
};

exports.Prisma.JsonNullValueFilter = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull,
  AnyNull: Prisma.AnyNull
};


exports.Prisma.ModelName = {
  users: 'users',
  documents: 'documents',
  profiles: 'profiles',
  bets: 'bets',
  betsEvents: 'betsEvents',
  betBonuses: 'betBonuses',
  freeSpins: 'freeSpins',
  games: 'games',
  transactions: 'transactions',
  wallets: 'wallets',
  casinoGames: 'casinoGames',
  admins: 'admins',
  agente: 'agente',
  comision: 'comision',
  concesionario: 'concesionario',
  subconcesionario: 'subconcesionario',
  transaccion: 'transaccion',
  activity: 'activity',
  retries: 'retries',
  movimientos: 'movimientos',
  agents_bets: 'agents_bets',
  bets_events: 'bets_events',
  bonuses: 'bonuses',
  sesiones: 'sesiones',
  vouchers: 'vouchers',
  pagos_comisiones: 'pagos_comisiones',
  agents_vouchers: 'agents_vouchers',
  referrals: 'referrals',
  raffle: 'raffle',
  raffle_tickets: 'raffle_tickets',
  users_raffle: 'users_raffle',
  sessions: 'sessions',
  commissions: 'commissions',
  partners: 'partners',
  affiliates_sessions: 'affiliates_sessions'
};

/**
 * This is a stub Prisma Client that will error at runtime if called.
 */
class PrismaClient {
  constructor() {
    return new Proxy(this, {
      get(target, prop) {
        let message
        const runtime = getRuntime()
        if (runtime.isEdge) {
          message = `PrismaClient is not configured to run in ${runtime.prettyName}. In order to run Prisma Client on edge runtime, either:
- Use Prisma Accelerate: https://pris.ly/d/accelerate
- Use Driver Adapters: https://pris.ly/d/driver-adapters
`;
        } else {
          message = 'PrismaClient is unable to run in this browser environment, or has been bundled for the browser (running in `' + runtime.prettyName + '`).'
        }
        
        message += `
If this is unexpected, please open an issue: https://pris.ly/prisma-prisma-bug-report`

        throw new Error(message)
      }
    })
  }
}

exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
